if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      // Fitwell: auto-load the 3D model on render instead of waiting for the
      // poster click, so it behaves like the admin portal's viewer (shows the
      // spinning buckle straight away). `loadContent(false)` avoids stealing
      // focus/scroll on page load.
      connectedCallback() {
        if (this.getAttribute('loaded')) return;
        requestAnimationFrame(() => {
          if (!this.getAttribute('loaded') && this.querySelector('template')) {
            this.loadContent(false);
          }
        });
      }

      loadContent() {
        super.loadContent(false);

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        const viewer = this.querySelector('model-viewer');
        this.modelViewerUI = new Shopify.ModelViewerUI(viewer);
        this.enableAutoRotate(viewer);
      }

      // Fitwell: continuously spin the model, matching the in-app viewer. Delay
      // 0 means it resumes immediately after a drag instead of sitting still.
      enableAutoRotate(viewer) {
        if (!viewer) return;
        viewer.setAttribute('camera-controls', '');
        viewer.setAttribute('auto-rotate', '');
        viewer.setAttribute('auto-rotate-delay', '0');
        viewer.setAttribute('rotation-per-second', '30deg');
        viewer.setAttribute('interaction-prompt', 'none');
        // Fitwell: soft contact shadow under the buckle so it sits on the
        // surface instead of floating, matching the product photography.
        viewer.setAttribute('shadow-intensity', '1.6');
        viewer.setAttribute('shadow-softness', '0.9');
        // Fitwell: slate-grey backdrop (#464449) sampled from the product
        // photos, so the 3D model sits on the same grey as the gallery images.
        viewer.style.backgroundColor = '#464449';
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
